<template>
  <div class="" v-if="broker != null">
    <div class="text-base">
      Do you know the reason your client is seeking loan and its amount?
      If you do, let's quickly fill them out below.
    </div>

    <div class="label-line">
      <label class="label-standard">What is the primary reason this client is seeking credit for?</label>
    </div>  
          
    <div class="form-line">
      <select class="select-standard"
        :value="application.primary_reason != null ? application.primary_reason : -1"
        v-on:change="updateValue({
          objectType: 'application',
          key       : 'primary_reason', 
          value     : $event.target.value
        })">
        <option value="-1" disabled>Select an option...</option>
        <option value="0">Buy Home</option>
        <option value="1">Debt Consolidate</option>
        <option value="2">Refinance</option>
        <option value="3">Buy Investment Property</option>
        <option value="4">Renovation / Cash Out</option>
        <option value="5">Buy Land</option>
        <option value="7">Land &amp; Construction</option>
        <option value="6">Other</option>
      </select>
    </div>

    <div class="mt-8">
      <InputDollarValue 
        label="How much does this client want to borrow?"
        propertyKey="borrow"
        objectType="application"
        :value="application.borrow"
        :updateValue="updateValue" />
    </div>
    
    <div class="text-center mt-20 flex items-center justify-center">
      <div class="inline-block bg-green-600 w-3 h-3 rounded-full"></div>
      <div class="inline-block bg-gray-200 w-12 mx-2" style="height:2px;"></div>
      <div class="inline-block bg-green-600 w-3 h-3 rounded-full"></div>
      <div class="inline-block bg-gray-200 w-12 mx-2" style="height:2px;"></div>
      <div class="inline-block bg-gray-400 w-3 h-3 rounded-full"></div>
    </div>

    <div class="mt-4 text-xs">
      <table class="w-full">
        <tr>
          <td class="w-1/3">
            <router-link 
              :to="{
                name  : 'broker-onboard-first-client-one',
                params: {
                  brokerId: $route.params.brokerId,
                  data    : encodeURIComponent(JSON.stringify(this.application))
                }
              }"
              tag="a" 
              class="rounded px-4 py-2 text-xs bg-gray-500 hover:bg-gray-600 text-white float-left">
              <svg width="16" height="16" stroke-width="2" class="float-left" style="margin-top:1px;" stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#chevron-left"/>
              </svg>
              Back
            </router-link>
          </td>
          <td class="w-1/3">
            <div class="text-gray-600 text-center">Step 2 of 3</div>
          </td>
          <td class="w-1/3">
            <button
              @click.prevent="next()"
              :class="{ 
                'rounded px-4 py-2 text-xs float-right'    : true,
                'bg-blue-500 hover:bg-blue-600 text-white' : broker.profile_image != null,
                'bg-gray-500 hover:bg-gray-600 text-white' : broker.profile_image == null
              }">

              <span class="float-left">Next</span>

              <svg width="16" height="16" stroke-width="2" class="float-left" style="margin-top:1px;" stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#chevron-right"/>
              </svg>
            </button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import { EventBus }     from '@/shared/event-bus'
  import InputDollarValue from '@/shared/components/form/InputDollarValue'
  import SubmitButton2    from '@/shared/components/form/SubmitButton2'
  
  export default {

    components: {
      InputDollarValue,
      SubmitButton2
    },

    data () {
      return {
        loading    : false,
        broker     : null,
        application: {
          primary_reason: null,
          borrow        : null
        }
      }
    },

    created() {
      this.getBroker({
        brokerId: this.$route.params.brokerId
      }, (broker) => {
        this.broker = broker
      })

      if(this.$route.params.data != null) {
        this.application = JSON.parse(decodeURIComponent(this.$route.params.data))
      }

      if(this.application.primary_reason == null) {
        this.application.primary_reason = null
      }

      if(this.application.borrow == null) {
        this.application.borrow = null
      }
    },

    methods : {
      updateValue(params) {
        this.application[params.key] = params.value
      },

      next() {
        this.$router.push({
          name  : 'broker-onboard-first-client-three',
          params: {
            brokerId: this.broker.id,
            data    : encodeURIComponent(JSON.stringify(this.application))
          }
        })
      }
    },
  }
</script>